<template>
  <page>
    <div class="m-grid__item m-grid__item--fluid m-wrapper">
      <div class="m-subheader ">
        <div class="d-flex align-items-center">
          <div class="mr-auto">
            <h1 class="m-subheader__title" v-encode="pageTitle"></h1>
          </div>
        </div>
      </div>
      <div class="m-content"  v-if="this.rewards.length">
        <div class="row">
          <reward-grid-item v-for="order in ordersSliced" order :reward="order" :key="order.id"></reward-grid-item>
        </div>
        <div v-if="isThereMore" class="row">
          <div class="col m--align-center">
            <button type="button" class="btn btn-sm m-btn--custom m-btn--pill btn-ls"
                    @click="showMore">Załaduj więcej
            </button>
          </div>
        </div>
      </div>
      <div class="m-content" v-if="!this.rewards.length">
        <div class="m-portlet m-portlet--full-height">
          <div class="m-portlet__body">
            <div class="tab-content">
              <div class="tab-pane active" id="m_widget2_tab1_content" aria-expanded="true">
                Brak zamówionych nagród
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <digital-reward-modal v-if="this.rewards.length"/>
    <material-reward-modal v-if="this.rewards.length"/>


  </page>
</template>

<script>
import {mapState} from 'vuex'
import Page from "./Page";
import Encode from "@/directives/encode";
import DigitalRewardModal from "../modal/DigitalRewardModal";
import Timeline from "@/components/timeline/Timeline";
import ReceivedRewardsTimelineItem from "@/components/timeline/items/ReceivedRewardsTimelineItem";
import PageTitle from "@/mixins/pageTitle";
import BeforeRoute from "@/mixins/beforeRoute";
import RewardGridItem from "@/components/reward/RewardGridItem";
import MaterialRewardModal from "@/components/modal/MaterialRewardModal";

export default {
  name: "ReceivedRewardsPage",
  components: {
    MaterialRewardModal,
    RewardGridItem,
    ReceivedRewardsTimelineItem,
    Timeline,
    DigitalRewardModal,
    Page,
  },
  mixins: [
      BeforeRoute('fetchRewards'),
      PageTitle('Zamówione nagrody')
  ],
  directives: {
    Encode
  },
  data() {
    return {
      showOnPage: 6,
      timelineItem: ReceivedRewardsTimelineItem,
    }
  },
  methods: {
    showMore() {
      this.showOnPage = this.showOnPage + 3;
    },
    resetShowOnPage() {
      this.showOnPage = this.rewardsPerPage;
    }
  },
  computed: {
    ...mapState({
      rewards: state => state.rewards.rewards,
    }),
    ordersSliced() {
      return this.rewards.slice().slice(0, this.showOnPage)
    },
    isThereMore() {
      return this.showOnPage < this.rewards.length;
    },
  }
}
</script>

<style scoped>

</style>
